module.exports = __webpack_public_path__ + "static/img/fd.6d1f895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fd.png
// module id = hSSm
// module chunks = 1